@if (!isSubmissionSuccess) {
  <third-party-common-layout class="accept-reject-claim-wrapper">
    <div class="card-header">
      <div class="row">
        <div class="col card-heading">{{"vehicle_assessment_request" | translate }}</div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="card-body mobile-view">
      <form [formGroup]="assessmentRequestForm"
        class="fx-col gap-16">
        <section class="fx-col gap-16">
          <div class="section-title">{{'vehicle_information' | translate}}</div>
          <div class="row">
            <div class="fx-col col-3">
              <label>{{"vehicle_make" | translate }}</label>
              <span>{{claimDetails?.vehicleMetaData?.make || '-'}}</span>
            </div>
            <div class="fx-col col-3">
              <label>{{"vehicle_model" | translate }}</label>
              <span>{{claimDetails?.vehicleMetaData?.model || '-'}}</span>
            </div>
            <div class="fx-col col-3">
              <label>{{"vin_number" | translate }}</label>
              <span>{{claimDetails?.vehicleMetaData?.vinNum || '-'}}</span>
            </div>
            <div class="fx-col col-3">
              <label>{{"vehicle_plate_number" | translate }}</label>
              <span>{{claimDetails?.vehicleMetaData?.plateNo || '-'}}</span>
            </div>
          </div>
          <div class="row">
            <div class="fx-col col-3">
              <label>{{"accident_report_number" | translate }}</label>
              <span>{{claimDetails?.lossDetails?.incidentNo || claimDetails?.lossDetails?.policeReferenceNo ||
              '-'}}</span>
            </div>
          </div>
        </section>
        <section class="fx-col gap-16">
          <div class="section-title">{{'estimated_repair_cost' | translate}}</div>
          <div class="row">
            <div class="col-4">
              <div class="form-row">
                <xa-numeric label="{{'parts_total_cost' | translate}}"
                  placeholder="{{'enter_amount' | translate}}"
                  formControlName="partsTotalCost"
                  [required]="true"
                [textAddon]="currencyName"></xa-numeric>
              </div>
            </div>
            <div class="col-4">
              <div class="form-row">
                <xa-numeric label="{{'labour_total_cost' | translate}}"
                  placeholder="{{'enter_amount' | translate}}"
                  formControlName="labourTotalCost"
                  [required]="true"
                [textAddon]="currencyName"></xa-numeric>
              </div>
            </div>
            <div class="col-4">
              <div class="form-row grand-total-row">
                <xa-numeric label="{{'grand_total' | translate}}"
                  placeholder="{{'enter_amount' | translate}}"
                  formControlName="grandTotal"
                  [required]="true"
                  [readonly]="true"
                [textAddon]="currencyName"></xa-numeric>
              </div>
            </div>
          </div>
        </section>
        <label class="info-msg">*{{'please_provide_amount_including_vat' | translate}}*</label>
        <section class="fx-col gap-16">
          <div class="section-title">{{'additional_notes' | translate}}</div>
          <div class="row">
            <div class="col-12">
              <div class="form-row">
                <xa-textarea label="{{'notes' | translate}}"
                  placeholder="{{'enter_additional_notes_msg' | translate}}"
                  formControlName="notes"
                [canResize]="false"></xa-textarea>
              </div>
            </div>
          </div>
        </section>
        <section class="fx-col gap-16">
          <div class="section-title">{{'documents_optional' | translate}}</div>
          <div class="fx-col gap-5">
            <label>{{'attach_estimation_esurvey_report' | translate}}</label>
            <div class="image-container"
              [ngClass]="{'has-image': surveyMedia?.isUploadSuccess}">
              <div class="attachment-container fx-1 fx-col gap-10">
                @if (surveyMedia?.isUploadSuccess) {
                  <div class="img-wrapper">
                    @if (!surveyMedia?.contentType.includes('pdf')) {
                      <img alt="attachment"
                        [src]="surveyMedia?.getURL"
                        class="logo-image" />
                      } @else {
                        <mat-icon class='pdf-icon'
                          svgIcon="pdf-file"
                          aria-hidden="false"
                        aria-label="pdf-file icon"></mat-icon>
                      }
                    </div>
                    <div class="status-container">
                      <mat-icon svgIcon="check-circle-filled"
                      class="success"></mat-icon>
                    </div>
                  } @else {
                    <div class="img-wrapper">
                      <img alt="default"
                        src="assets/img/attachment-placeholder.png" />
                      </div>
                      <div class="status-container">
                        <mat-icon svgIcon="check-circle"
                        class="no-image"></mat-icon>
                      </div>
                    }
                  </div>
                  <div class="d-flex justify-space-between align-center">
                    <div class="attachment-label">{{'other' | translate}}</div>
                    <xa-button type="outline-radius"
                      size="sm"
                      (click)="uploadDocument()"
                      (keyPress)="uploadDocument()">
                      <mat-icon svgIcon="upload"></mat-icon>
                      {{'upload' | translate}}
                    </xa-button>
                  </div>
                  <chq-custom-loader [showLoading]="surveyMedia?.uploadInProgress"></chq-custom-loader>
                </div>
              </div>
            </section>
            <section class="fx-col gap-16">
              <div class="section-title d-flex align-center gap-20">{{'vehicle_photos_optional' | translate}}
                <xa-button type="outline-radius"
                  (click)="bulkUpload()"
                  (keyPress)="bulkUpload()"
                  [disabled]="imageFiles?.length === totalImageCount">
                  <mat-icon svgIcon="upload"></mat-icon>
                  {{'bulk_upload' | translate}}
                </xa-button>
              </div>
              <div class="fx-col gap-5">
                <label>{{'add_vehicle_photos' | translate}}({{uploadedImageCount}}/{{totalImageCount}})</label>
                <div class="d-flex gap-16"
                  style="flex-wrap: wrap;">
                  @for (item of imageFiles; track item) {
                    <div class="image-container"
                      [ngClass]="{'has-image': item?.isUploadSuccess}">
                      <div class="attachment-container fx-1 fx-col gap-10">
                        @if (item?.isUploadSuccess) {
                          <div class="img-wrapper">
                            <img alt="attachment"
                              [src]="item?.rawAzureBlobUrl"
                              class="logo-image" />
                            </div>
                            <div class="status-container">
                              <mat-icon svgIcon="check-circle-filled"
                              class="success"></mat-icon>
                            </div>
                          } @else {
                            <div class="img-wrapper">
                              <img alt="default"
                                src="assets/img/attachment-placeholder.png" />
                              </div>
                              <div class="status-container">
                                <mat-icon svgIcon="check-circle"
                                class="no-image"></mat-icon>
                              </div>
                            }
                          </div>
                          <div class="d-flex justify-space-between align-center">
                            <div class="attachment-label">{{'vehicle' | translate}}</div>
                            @if (item.isUploadSuccess) {
                              <div
                                class="more-action"
                                (click)="confirmDelete(item)"
                                (keyPress)="confirmDelete(item)">
                                <mat-icon svgIcon="delete"></mat-icon>
                              </div>
                            }
                          </div>
                          <chq-custom-loader [showLoading]="item?.uploadInProgress"></chq-custom-loader>
                        </div>
                      }
                    </div>
                  </div>
                </section>
              </form>
              <div class="row mt-40">
                <div class="col-auto ml-auto">
                  <xa-button (click)="handleFormSubmit()"
                    [disabled]="assessmentRequestForm.invalid || hasActiveUpload">{{'submit_assessment' |
                  translate}}</xa-button>
                </div>
              </div>
            </div>
          </third-party-common-layout>
        } @else {
          <div class="success-submission h-100 d-flex align-center justify-center">
            <div class="fx-col gap-24 success-submit-content">
              <mat-icon svgIcon="submit-success"></mat-icon>
              <div class="fx-col gap-8">
                <div class="title">{{'assessment_submitted_successfully' | translate}}</div>
                <div class="description">{{'assessment_submitted_to_insurer' | translate}}</div>
              </div>
            </div>
          </div>
        }

        <chq-upload [currentStep]="surveyMedia"
          currentPageName="file-claim-document"
          [isCurrentAdditionalModeMultiple]="false"
          #chqUpload
          (imageOutput)="handleDocumentOutput($event);"
        [maxFileSize]="5242880"></chq-upload>

        <chq-upload [isCurrentAdditionalModeMultiple]="true"
          [isMultiple]="true"
          [currentPageName]="'bulkUploadTemplate'"
          #xaUpload
          (imageOutput)="handleImageOutput($event);"
        [maxFileSize]="5242880"></chq-upload>